export const initWikiRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
      {
        path: "/manage/wiki",
        name: "wiki",
        component: () => import("@/pages/manage/wiki/index.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
      {
        path: "/manage/wiki/:id",
        name: "disease-id",
        component: () => import("@/pages/manage/wiki/id.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
    ];
